module.exports = __webpack_public_path__ + "media/images/categories/office-a8696482838b76e5be6d8d9959bf62e9.png";